import { IReportNote, IReportNoteApi } from "../../../../api/types/reports/IReportNote";
import { decodeHtmlEntities } from "./decodeHtmlEntities";

export function normalizeReportNote(raw: IReportNoteApi): IReportNote {
  return {
    id: raw.id,
    date: raw.last_update,
    text: decodeHtmlEntities(raw.note),
  };
}
